import BusStopComponent from './BusStopComponent';
import CardComponent from './CardComponent';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import * as React from 'react';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import TxpStringDefinitions from 'txp-data/lib/schema/configSchema/TxpStringDefinitions';

export interface CardCollectionProps extends React.HTMLProps<HTMLDivElement> {
    isBusStopEnabled?: boolean;
    cardItems: CardItem[];
    txpStyle: TxpStyle;
    txpConfiguration: TxpConfiguration;
    strings: TxpStringDefinitions;
}

export interface CardCollectionState {
    isSpinnerShown: boolean;
}

export default class CardCollection extends React.Component<
    CardCollectionProps,
    CardCollectionState
> {
    constructor(props: CardCollectionProps) {
        super(props);
        this.state = {
            isSpinnerShown: false,
        };
    }

    render() {
        let { cardItems, isBusStopEnabled, txpStyle, txpConfiguration } = this.props;
        let renderedCards: JSX.Element[] = [];
        cardItems.forEach((card: CardItem, index: number) => {
            if (card) {
                if (isBusStopEnabled && card.busStopData) {
                    renderedCards.push(
                        <BusStopComponent
                            key={index}
                            cardItem={card}
                            txpStyle={txpStyle}
                            txpConfiguration={txpConfiguration}
                            isSpinnerShown={this.state.isSpinnerShown}
                            onSpinnerStateChanged={this.onSpinnerStateChanged}
                        />
                    );
                } else {
                    renderedCards.push(
                        <CardComponent
                            key={index}
                            cardItem={card}
                            txpStyle={txpStyle}
                            txpConfiguration={txpConfiguration}
                            isSpinnerShown={this.state.isSpinnerShown}
                            onSpinnerStateChanged={this.onSpinnerStateChanged}
                        />
                    );
                }
            }
        });
        return <div role="listbox">{renderedCards}</div>;
    }

    private onSpinnerStateChanged = (state: boolean): void => {
        this.setState({
            isSpinnerShown: state,
        });
    };
}
